if (!customElements.get('product-modal')) {
  customElements.define(
    'product-modal',
    class ProductModal extends ModalDialog {
      constructor() {
        super();
        this.boundKeydown = this.onKeydown.bind(this);
        this.querySelectorAll('.product-media-modal__nav').forEach((button) => {
          button.addEventListener('click', (event) => {
            event.preventDefault();
            event.stopPropagation();
            if (button.name === 'previous') this.navigate(-1);
            if (button.name === 'next') this.navigate(1);
          });
          button.addEventListener('pointerup', (event) => event.stopPropagation());
        });
        this.initSwipeNavigation();
      }

      hide() {
        document.removeEventListener('keydown', this.boundKeydown);
        super.hide();
        this.updateNavButtons();
      }

      show(opener) {
        super.show(opener);
        if (typeof window.syncOdpInlineGallery === 'function') {
          try {
            window.syncOdpInlineGallery();
          } catch {
            /* optional */
          }
        }
        if (typeof window.odpEnforceDualMotorProductModalFromThumbs === 'function') {
          window.odpEnforceDualMotorProductModalFromThumbs(this);
        } else if (typeof window.odpApplyTrayProductModalFilter === 'function') {
          window.odpApplyTrayProductModalFilter();
        } else if (typeof window.odpApplyCableProductModalFilter === 'function') {
          window.odpApplyCableProductModalFilter();
        } else if (typeof window.odpApplyVariantProductModalFilter === 'function') {
          window.odpApplyVariantProductModalFilter();
        }
        this.showActiveMedia();
        if (typeof window.odpEnforceDualMotorProductModalFromThumbs === 'function') {
          window.odpEnforceDualMotorProductModalFromThumbs(this);
        } else if (typeof window.odpApplyVariantProductModalFilter === 'function') {
          window.odpApplyVariantProductModalFilter();
        }
        this.showActiveMedia();
        this.updateNavButtons();
        document.addEventListener('keydown', this.boundKeydown);
      }

      initSwipeNavigation() {
        const surface = this.querySelector('.product-media-modal__dialog');
        if (!surface) return;

        let startX = 0;
        let startY = 0;
        const minSwipe = 56;
        const mobileQuery = window.matchMedia('(max-width: 749px)');

        surface.addEventListener(
          'touchstart',
          (event) => {
            if (!this.hasAttribute('open') || event.touches.length !== 1) return;
            if (event.target.closest('.product-media-modal__nav, .product-media-modal__toggle')) return;
            startX = event.touches[0].clientX;
            startY = event.touches[0].clientY;
          },
          { passive: true }
        );

        surface.addEventListener(
          'touchend',
          (event) => {
            if (!this.hasAttribute('open')) return;
            const touch = event.changedTouches[0];
            if (!touch) return;
            const deltaX = touch.clientX - startX;
            const deltaY = touch.clientY - startY;
            const absX = Math.abs(deltaX);
            const absY = Math.abs(deltaY);
            if (absX < minSwipe && absY < minSwipe) return;

            if (mobileQuery.matches && deltaY > 0 && absY >= minSwipe && absY > absX) {
              event.preventDefault();
              this.hide();
              return;
            }

            if (absX >= minSwipe && absX > absY) {
              event.preventDefault();
              this.navigate(deltaX < 0 ? 1 : -1);
            }
          },
          { passive: false }
        );
      }

      onKeydown(event) {
        if (!this.hasAttribute('open')) return;
        if (event.code === 'Escape') {
          event.preventDefault();
          this.hide();
          return;
        }
        if (event.code === 'ArrowLeft') {
          event.preventDefault();
          this.navigate(-1);
        }
        if (event.code === 'ArrowRight') {
          event.preventDefault();
          this.navigate(1);
        }
      }

      getContentRoot() {
        return this.querySelector('.product-media-modal__content');
      }

      getVisibleMediaItems() {
        if (document.getElementById('odp-variant-gallery-map')) {
          if (typeof window.odpGetVisibleProductModalMediaItems === 'function') {
            const curated = window.odpGetVisibleProductModalMediaItems(this) || [];
            const visibleCurated = this.filterVisibleModalMediaItems(curated);
            if (visibleCurated.length) return visibleCurated;
          }
          const root = this.getContentRoot();
          if (!root) return [];
          return [...root.children].filter(
            (element) =>
              element.hasAttribute('data-media-id') &&
              !element.classList.contains('odp-modal-media--hidden')
          );
        }
        const root = this.getContentRoot();
        if (!root) return [];
        return [...root.children].filter(
          (element) =>
            element.hasAttribute('data-media-id') && !element.classList.contains('odp-modal-media--hidden')
        );
      }

      getActiveMediaItem() {
        const visible = this.getVisibleMediaItems();
        return visible.find((element) => element.classList.contains('active')) || visible[0] || null;
      }

      navigate(delta) {
        if (typeof window.odpEnforceDualMotorProductModalFromThumbs === 'function') {
          window.odpEnforceDualMotorProductModalFromThumbs(this);
        } else if (typeof window.odpApplyVariantProductModalFilter === 'function') {
          window.odpApplyVariantProductModalFilter();
        } else if (typeof window.odpApplyCableProductModalFilter === 'function') {
          window.odpApplyCableProductModalFilter();
        } else if (typeof window.odpApplyTrayProductModalFilter === 'function') {
          window.odpApplyTrayProductModalFilter();
        }
        const items = this.getVisibleMediaItems();
        if (items.length < 2) return;

        const active = this.getActiveMediaItem();
        let index = active ? items.indexOf(active) : 0;
        if (index < 0) index = 0;

        const nextIndex = (index + delta + items.length) % items.length;
        const nextItem = items[nextIndex];
        const nextId = nextItem.getAttribute('data-media-id');
        if (!nextId) return;

        if (this.openedBy?.setAttribute) {
          this.openedBy.setAttribute('data-media-id', nextId);
        }

        this.activateMediaElement(nextItem);
        this.syncOdpGallery(nextId);
        this.updateNavButtons();
      }

      syncOdpGallery(mediaId) {
        const zoomBtn = document.getElementById('odp-main-image-zoom');
        if (zoomBtn) zoomBtn.setAttribute('data-media-id', String(mediaId));

        const modalOpen = this.classList.contains('odp-tray-media-modal') && this.hasAttribute('open');
        if (modalOpen && typeof window.odpSetTrayModalActiveMediaId === 'function') {
          window.odpSetTrayModalActiveMediaId(mediaId, { fromModalNav: true });
          return;
        }

        const thumb = document.querySelector(`.odp-gallery__thumb[data-media-id="${CSS.escape(mediaId)}"]`);
        if (
          thumb &&
          !thumb.classList.contains('odp-gallery__thumb--hidden') &&
          typeof window.changeMainProductImage === 'function'
        ) {
          window.changeMainProductImage(thumb);
        }
      }

      updateNavButtons() {
        const items = this.getVisibleMediaItems();
        const showNav = this.hasAttribute('open') && items.length > 1;
        this.querySelectorAll('.product-media-modal__nav').forEach((button) => {
          button.hidden = !showNav;
          button.disabled = false;
        });
      }

      activateMediaElement(activeMedia) {
        if (!activeMedia) return;

        const activeId = activeMedia.getAttribute('data-media-id');
        const root = this.getContentRoot();
        if (!root) return;

        root.querySelectorAll(':scope > [data-media-id]').forEach((element) => {
          const isVisible = !element.classList.contains('odp-modal-media--hidden');
          element.classList.toggle('active', isVisible && element.getAttribute('data-media-id') === activeId);
        });

        const activeMediaTemplate = activeMedia.querySelector('template');
        const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
        activeMedia.classList.add('active');

        const container = this.querySelector('[role="document"]');
        if (container) {
          container.scrollTop = 0;
          container.scrollLeft = 0;
        }

        window.pauseAllMedia?.();

        if (activeMedia.nodeName === 'DEFERRED-MEDIA' && activeMediaContent?.querySelector('.js-youtube')) {
          activeMedia.loadContent();
        }
      }

      filterVisibleModalMediaItems(items) {
        return items.filter((element) => !element.classList.contains('odp-modal-media--hidden'));
      }

      showActiveMedia() {
        const openedMediaId = this.openedBy?.getAttribute?.('data-media-id');
        let visibleItems = this.filterVisibleModalMediaItems(this.getVisibleMediaItems());
        if (
          !visibleItems.length &&
          typeof window.odpRevealProductModalFromGalleryThumbs === 'function'
        ) {
          visibleItems = this.filterVisibleModalMediaItems(
            window.odpRevealProductModalFromGalleryThumbs(this) || []
          );
        }
        let activeMedia = openedMediaId
          ? visibleItems.find((element) => element.getAttribute('data-media-id') === openedMediaId)
          : null;
        if (!activeMedia) activeMedia = visibleItems[0] || null;
        if (activeMedia && this.openedBy?.setAttribute) {
          this.openedBy.setAttribute('data-media-id', activeMedia.getAttribute('data-media-id') || '');
        }
        if (activeMedia) this.activateMediaElement(activeMedia);
      }
    }
  );
}
